import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const init = () => {
  const parallaxElms = document.querySelectorAll('.js-parallax');

  if(window.innerWidth < 961) {
    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    ScrollTrigger.refresh();
    return;
  }
  parallaxElms.forEach((elm) => {
    const percent = elm.dataset.percent ? Number(elm.dataset.percent) : 20;
    gsap.fromTo(
      elm,
      {
        yPercent: percent / 3,
      },
      {
        yPercent: -percent / 3,
        ease: "none",
        scrollTrigger: {
          name: "parallax",
          trigger: elm,
          start: "top bottom",
          end: "bottom top",
          markers: false,
          scrub: 0,
        },
      }
    );
  });

  const bgParallaxElms = document.querySelectorAll('.js-bgParallax');
  bgParallaxElms.forEach((elm) => {
    const img = elm.querySelector('picture');
    let percent = 20;
    gsap.fromTo(
      img,
      {
        yPercent: percent / 2,
      },
      {
        yPercent: -percent / 2,
        ease: "none",
        scrollTrigger: {
          name: "parallax",
          trigger: img,
          start: "top bottom",
          end: "bottom top",
          markers: false,
          scrub: 0,
        },
      }
    );
  });
}

const resize = () => {
  const parallaxElms = document.querySelectorAll('.js-parallax');

  if(window.innerWidth < 961) {
    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    return;
  }
  parallaxElms.forEach((elm) => {
    const percent = elm.dataset.percent ? Number(elm.dataset.percent) : 20;
    gsap.fromTo(
      elm,
      {
        yPercent: percent / 2,
      },
      {
        yPercent: -percent / 2,
        ease: "none",
        scrollTrigger: {
          trigger: elm,
          start: "top bottom",
          end: "bottom top",
          markers: false,
          scrub: 0,
        },
      }
    );
  });
}

export {
  init,
  resize,
};